import { connect } from 'react-redux'
import cardDateSelector from './cardDateSelector'
import CardDate from './CardDate'
import { sagaActions } from 'store/sagas'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  cardDateSelector,
  {
    requestAddAlarm: sagaActions.requestAddAlarm,
    requestRemoveAlarm: sagaActions.requestRemoveAlarm
  }
)(CardDate))
